import React, { useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import {
	HomeOutlined,
	EyeOutlined,
	SoundOutlined,
	RobotOutlined,
	SettingOutlined,
	FileSearchOutlined
} from '@ant-design/icons';
import { useSelector } from 'react-redux';
import AccountProfile from '../account-profile/account-profile';
import { FileListRoles, UploadRoles, SettingRoles, AllSettingRoles } from '../../constants/roles';
import './sidebar.scss';

const { Sider } = Layout;
const { SubMenu } = Menu;

const SidebarMenuLink = ({ to, icon, children }) => (
	<Link
		className={icon ? 'sidebar-menu-link sidebar-menu-link--with-icon' : 'sidebar-menu-link'}
		to={to}
		title={typeof children === 'string' ? children : undefined}
	>
		{icon && <span className='sidebar-menu-link__icon'>{icon}</span>}
		<span className='sidebar-menu-link__label'>{children}</span>
	</Link>
);

const SideBar = ({ selectedKey, openKey }) => {
	const currentUser = useSelector((state) => state.auth.currentUser);
	const [collapsed, setCollapsed] = useState(false);

	var ocrRoleName = currentUser?.ocrRole?.name;
	var companyId = currentUser?.companyId;
	console.log("Current User", currentUser);

	const routeByKey = {
		'1': '/',
		'3': '/ocr/file-list',
		'5': '/ocr/upload',
		'asap-cases': '/asap/cases',
		'event-list': '/events',
		'upload-recording': '/upload-recording',
		'tag-list': '/tags',
		'assistant-stream': '/streams',
		'process-config': '/rpa/process-config',
		'task-history': '/rpa/task-history',
		'get-otp': '/rpa/get-otp',
		'main-logging': '/rpa/main-logging',
		'pipeline': '/pd/pipeline',
		'discovery': '/pd/discovery',
		'companies': '/settings/companies'
	};

	const getPathByKey = (key) => {
		if (key === 'settings-company') {
			return companyId ? '/settings/companies/' + companyId : '/settings/companies';
		}
		return routeByKey[key];
	};

	const renderMenuItem = (key, label, icon = null) => {
		const path = getPathByKey(key);
		if (!path) return null;

		return (
			<Menu.Item key={key}>
				<SidebarMenuLink to={path} icon={icon}>
					{label}
				</SidebarMenuLink>
			</Menu.Item>
		);
	};

	const toggleCollapsed = () => {
		setCollapsed(!collapsed);
	};

	return (
		<Sider
			width={260}
			breakpoint='lg'
			collapsedWidth='0'
			theme='light'
			collapsible
			collapsed={collapsed}
			onCollapse={toggleCollapsed}
		>
			<Link to='/account'>
				<AccountProfile
					fullName='Elon Musk'
					jobTitle='CEO'
				></AccountProfile>
			</Link>
			<Menu
				inlineIndent={24}
				defaultSelectedKeys={selectedKey}
				mode='inline'
				defaultOpenKeys={openKey}
			>
				{renderMenuItem('1', 'Dashboard', <HomeOutlined />)}
				{currentUser?.isActivated && ocrRoleName && ocrRoleName == "Super Admin" && (
					<SubMenu
						key='agents'
						icon={<SoundOutlined />}
						title='Automated.Agents'
					>
						{/* <Menu.Item key='8' onClick={changePage}>
              Dashboard
            </Menu.Item> */}
						{renderMenuItem('event-list', 'Event List')}
						{renderMenuItem('tag-list', 'Tag List')}
						{renderMenuItem('assistant-stream', 'Assistant Streams')}
						{renderMenuItem('upload-recording', 'Upload Recording')}
					</SubMenu>
				)}
				{currentUser?.isActivated && (currentUser.hasOcrLicense || ocrRoleName == "Super Admin" || companyId == "0424f17f-a0c0-47f1-892f-439c3a907f46") && (
					<SubMenu
						key='documents'
						icon={<EyeOutlined />}
						title='Automated.Documents'
					>
						{/* <Menu.Item key='10' onClick={changePage}>
							Dashboard
						</Menu.Item> */}
						{ocrRoleName && FileListRoles.includes(ocrRoleName) &&
							renderMenuItem('asap-cases', 'ASAP Cases')
						}
						{ocrRoleName && FileListRoles.includes(ocrRoleName) && companyId != "0424f17f-a0c0-47f1-892f-439c3a907f46" &&
							renderMenuItem('3', 'File List')
						}
						{ocrRoleName && UploadRoles.includes(ocrRoleName) && companyId != "0424f17f-a0c0-47f1-892f-439c3a907f46" && renderMenuItem('5', 'Upload File')}
						{/* <Menu.Item key='5' onClick={changePage}>
							Review File
						</Menu.Item> */}
					</SubMenu>
				)}
				{ocrRoleName && ocrRoleName == "Super Admin" && (
					<SubMenu
						key='rpa'
						icon={<RobotOutlined />}
						title='Automated.RPA'
					>
						{/* <Menu.Item key='10' onClick={changePage}>
							Dashboard
						</Menu.Item> */}
						<SubMenu key='configurations' title='Configurations'>
							{renderMenuItem('process-config', 'Process Config')}
							{/* <Menu.Item key='task-trigger' onClick={changePage}>
								Task Trigger
							</Menu.Item> */}
							{renderMenuItem('task-history', 'Task History')}
						</SubMenu>

						{renderMenuItem('main-logging', 'Main Loggings')}
						{renderMenuItem('get-otp', 'Get OTP')}
					</SubMenu>
				)}
				{currentUser?.isActivated && ocrRoleName == "Super Admin" && (
					<SubMenu
						key='pd'
						icon={<FileSearchOutlined />}
						title='Process Discovery'
					>
						{renderMenuItem('pipeline', 'Pipeline')}
						{renderMenuItem('discovery', 'Discovery')}
					</SubMenu>
				)}
				{ocrRoleName && SettingRoles.includes(ocrRoleName) && (
					renderMenuItem('settings-company', 'Settings', <SettingOutlined />)
				)}
				{ocrRoleName && AllSettingRoles.includes(ocrRoleName) && (
					<SubMenu
						key='settings'
						icon={<SettingOutlined />}
						title='Settings'
					>
						{renderMenuItem('companies', 'Companies')}
					</SubMenu>
				)}
			</Menu>
		</Sider>
	);
};

export default withRouter(SideBar);
